const AppConfig = {
  appName: 'アバター絵本を作成 | ÉHON INC.（えほんインク）'
}

export default AppConfig
